let TeamMembers = {
    init() {
        this.bind();
    },

    bind() {
        this.addForm();
        this.editForm();
        this.form();
        this.delete();
    },

    addForm() {
        let _this = this;

        const form = $('#teamMemberForm');

        if (form.length) {
            $(document).on('click', '.add-team-member', () => {
                form.find('#userId').val('');
                form.find('#userFirstName').val('');
                form.find('#userLastName').val('');
                form.find('#userEmail').val('');
                form.find('#userTeam').val('');
                form.find('#userBelongsToGroupSubscription').iCheck('uncheck');

                form.resetForm();
            });
            let submitBtn = Ladda.create(form.find('[type=submit]')[0]);

            form.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        window.location.reload();
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });
        }
    },

    editForm() {
        let _this = this;

        const form = $('#teamMemberForm');
        const modal = $('#teamMemberModal');

        $(document).on('click', '.edit-team-member', function () {
            const id = $(this).data('id');
            const row = $(this).closest('tr');

            $.get('/team-members/' + id + '/json', response => {
                if (response.success) {
                    const user = response.data;
                    let useGroupSubscription = user.group_admin.user.recurly_account_code !== null && user.details.seat_recurly_account_code === user.group_admin.user.recurly_account_code;

                    form.find('#userFirstName').val(user.details.first_name);
                    form.find('#userLastName').val(user.details.last_name);
                    form.find('#userEmail').val(user.user_email);
                    form.find('#userId').val(user.ID);
                    form.find('#userTeam').val(user.team.id);
                    form.find('#userBelongsToGroupSubscription').iCheck(useGroupSubscription ? 'check' : 'uncheck');

                    modal.modal('show');
                }
            });
        });
    },

    delete() {
        $(document).on('click', '.delete-team-member', function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');
            let team_id = $(this).data('team');

            swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this record!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.value) {
                    $.post('/teams/' + team_id + '/members/' + id,
                        {
                            _method: 'delete',
                            team_id: team_id
                        },
                        (result) => {
                            if (result.success) {
                                let table = row.closest('table').DataTable();
                                table.row(row).remove().draw();
                                swal(
                                    'Deleted!',
                                    'Team member has been deleted.',
                                    'success'
                                ).then((result) => {

                                });
                            }
                        });
                }
            });
        });
    },

    form() {
        let _this = this;
        const form = $('#teamMemberForm');
    },
};

$().ready(function () {
    window.TeamMembers = TeamMembers;
    window.TeamMembers.init();
});
